import { post, get, patch, deleted, Statementget } from "services";
import routes from "./routes";

const ClientServices = {
  getClientDropdown: async (params) => {
    const data = await get(routes.getClientDropdown, params);
    return data;
  },
  getVehicleForTT: async (params) => {
    const data = await get(routes.getVehicleForTT, params);
    return data;
  },
  getClientCosting: async (params) => {
    const data = await get(routes.getClientCosting, params);
    return data;
  },
  getClientCostingV2: async (params) => {
    const data = await get(routes.getClientCostingV2, params);
    return data;
  },
  getClientCostingSoaV1: async (params) => {
    const data = await get(routes.getClientCostingSoaV1, params);
    return data;
  },
  getClientCostingSoa: async (params) => {
    const data = await get(routes.getClientCostingSoa, params);
    return data;
  },
  getClientCostingStatement: async (params) => {
    const data = await Statementget(routes.getClientCosting, params);
    return data;
  },
  getClientInvoice: async (params) => {
    const data = await get(routes.getClientInvoice, params);
    return data;
  },
  getVehicleTTPreview: async (params) => {
    const data = await get(routes.getVehicleTTPreview, params);
    return data;
  },
  getClientInvoicePreview: async (params) => {
    const data = await get(routes.getClientInvoicePreview, params);
    return data;
  },
  updateClientCosting: async (obj) => {
    const data = await patch(routes.updateClientCosting, obj);
    return data;
  },
  removeClientCosting: async (obj) => {
    const data = await patch(routes.removeClientCosting, obj);
    return data;
  },
  approveTTStatus: async (obj) => {
    const data = await patch(routes.approveTTStatus, obj);
    return data;
  },
  getClientVin: async (params) => {
    const data = await get(routes.getClientVin, params);
    return data;
  },
  getStorageDetails: async (params) => {
    const data = await get(routes.getStorageDetails, params);
    return data;
  },
  getAllStorageDetails: async (params) => {
    const data = await get(routes.getAllStorageDetails, params);
    return data;
  },
  updateStorage: async (obj) => {
    const data = await patch(routes.updateStorage, obj);
    return data;
  },
  getTTVin: async (params) => {
    const data = await get(routes.getTTVin, params);
    return data;
  },
  getVehicleTT: async (params) => {
    const data = await get(routes.getVehicleTT, params);
    return data;
  },
  getBuyerId: async (params) => {
    const data = await get(routes.getBuyerId, params);
    return data;
  },
  getApprovalList: async (params) => {
    const data = await get(routes.getApprovalList, params);
    return data;
  },
  AddTT: async (obj) => {
    const data = await post(routes.AddTT, obj);
    return data;
  },
  updateTT: async (obj) => {
    const data = await patch(routes.updateTT, obj);
    return data;
  },
  uploadClientRate: async (obj) => {
    const data = await post(routes.uploadClientRate, obj);
    return data;
  },
  getTT: async (params) => {
    const data = await get(routes.getTT, params);
    return data;
  },
  getTTDetail: async (params) => {
    const data = await get(routes.getTTDetail, params);
    return data;
  },
  getClientRates: async (params) => {
    const data = await get(routes.getClientRates, params);
    return data;
  },
  getAppliedFunds: async (params) => {
    const data = await get(routes.getAppliedFunds, params);
    return data;
  },
  updateRates: async (obj) => {
    const data = await patch(routes.updateRates, obj);
    return data;
  },
  updateFundsApply: async (obj) => {
    const data = await post(routes.updateFundsApply, obj);
    return data;
  },
  updateFundsApplyV2: async (obj) => {
    const data = await post(routes.updateFundsApplyV2, obj);
    return data;
  },
  getShippingInvoice: async (params) => {
    const data = await get(routes.getShippingInvoice, params);
    return data;
  },
  getShippingInvoicePreview: async (params) => {
    const data = await get(routes.getShippingInvoicePreview, params);
    return data;
  },
  sendApproval: async (obj) => {
    const data = await post(routes.sendApproval, obj);
    return data;
  },
  deleteTT: async (params, payloadData) => {
    const data = await deleted(routes.deleteTT, params, payloadData);
    return data;
  },
  deleteVoucher: async (params) => {
    const data = await deleted(routes.deleteVoucher, params);
    return data;
  },
  deleteCostingEntries: async (parmas) => {
    const data = await deleted(routes.deleteCostingEntries, {}, parmas);
    return data;
  },
  reverseCostingEntries: async (parmas) => {
    const data = await patch(routes.reverseCostingEntries, parmas);
    return data;
  },
  getAllStorageSLP: async (params) => {
    const data = await get(routes.getAllSLP, params);
    return data;
  },
  deleteStorage: async (parmas) => {
    const data = await patch(routes.deleteStorage, parmas);
    return data;
  },
  getAllSLPVehicles: async (params) => {
    const data = await get(routes.getPrepaidAuction, params);
    return data;
  },
  getSLPVehicles: async (params) => {
    const data = await get(routes.getPrepaidauction, params);
    return data;
  },
  bookPrepaidAuction: async (obj) => {
    const data = await post(routes.bookPrepaidAuction, obj);
    return data;
  },
  updateSLPVehicles: async (params) => {
    const data = await patch(routes.updatePrepaidauction, params);
    return data;
  },
  SLPVehiclesDetails: async (params) => {
    const data = await get(routes.prepaidauctionDetails, params);
    return data;
  },
  SLPDelete: async (params) => {
    const data = await deleted(routes.deleteprepaidauction, params);
    return data;
  },
  updateClientCostingV2: async (params) => {
    const data = await patch(routes.updateClientCostingV2, params);
    return data;
  },
  specialDiscount: async (obj) => {
    const data = await post(routes.specialDiscount, obj);
    return data;
  },
  specialDiscountList: async (obj) => {
    const data = await get(routes.specialDiscountList, obj);
    return data;
  },
  specialDiscountDetails: async (params) => {
    const data = await get(routes.specialDiscountDetails, params);
    return data;
  },
  updateSpecialDiscount: async (params) => {
    const data = await patch(routes.updateSpecialDiscount, params);
    return data;
  },
  getDeleteSpecialDiscount: async (params) => {
    const data = await deleted(routes.deleteSpecialDiscount, params);
    return data;
  },

  getClientInvoiceList: async (params) => {
    const data = await get(routes.getClientInvoiceList, params);
    return data;
  },
};

export default ClientServices;
